import React from "react";
import {Flex, Heading} from "@aws-amplify/ui-react";
import EiaCard from "../../cards/EiaCard";
import D4ItemBaseStatSelect from "../../d4/D4ItemBaseStatSelect";
import {contains} from "../../../commons/Utils/ArrayUtils";
import {canHaveAspects, canHaveMythicAffix, canHaveSetAffix, canHaveUniqueAffix, ITEM_SUB_TYPES_WITHOUT_STATS} from "../../../commons/enums/D4Enums";
import {convertToD4ItemForRequest} from "../../../commons/Converter";
import D4AffixSelects from "../../d4/D4AffixSelects";
import D4ImplicitStatSelects from "../../d4/D4ImplicitStatSelects";
import EiaHelpButton from "../../EiaHelpButton";
import EiaImage from "../../EiaImage";
import helpBasicStats from "../../../resources/help/helpBasicStats.jpg";
import D4ItemSelects from "../../d4/D4ItemSelects";
import BaseEditAuctionDialog from "../BaseEditAuctionDialog";
import {DIABLO_4} from "../../../commons/enums/EiaEnums";
import {MAX_AFFIX_STATS_PER_ITEM, MAX_IMPLICIT_STATS_PER_ITEM} from "../../../commons/enums/D4Constants";

const game = DIABLO_4;

function D4EditAuctionDialog(props) {
    const {onClose, open, auction} = props;

    const [alert, setAlert] = React.useState(null)

    const [baseItem, setBaseItem] = React.useState({});
    const [baseStats, setBaseStats] = React.useState({});
    const [implicitStats, setImplicitStats] = React.useState([])
    const [updateImplicitStatsSelects, setUpdateImplicitStatsSelects] = React.useState(false);
    const [affixStats, setAffixStats] = React.useState([])
    const [updateStatsSelects, setUpdateStatsSelects] = React.useState(false);
    const [aspects, setAspects] = React.useState([])
    const [updateAspectSelects, setUpdateAspectSelects] = React.useState(false);
    const [uniqueAffixes, setUniqueAffixes] = React.useState([])
    const [updateUniqueAffixesSelects, setUpdateUniqueAffixesSelects] = React.useState(false);
    const [setAffixes, setSetAffixes] = React.useState([])
    const [updateSetAffixesSelects, setUpdateSetAffixesSelects] = React.useState(false);
    const [mythicAffixes, setMythicAffixes] = React.useState([])
    const [updateMythicAffixesSelects, setUpdateMythicAffixesSelects] = React.useState(false);

    const itemCanHaveAspects = canHaveAspects(baseItem);
    const itemCanHaveUniqueAffixes = canHaveUniqueAffix(baseItem);
    const itemCanHaveSetAffixes = canHaveSetAffix(baseItem);
    const itemCanHaveMythicAffixes = canHaveMythicAffix(baseItem);

    React.useEffect(() => {
        if(!auction) {
            return;
        }

        setAlert(null);

        // update baseItem
        let temp = {
            itemType: auction.itemType,
            itemSubType: auction.itemSubType,
            name: auction.itemName,
            title: auction.item.title,
            amount: auction.amount,
            rarity: auction.rarity
        };
        setBaseItem(temp);

        // update basic stats
        temp = {
            armor: auction.armor,
            allResist: auction.allResist,
            dps: auction.dps,
            levelRequirement: auction.levelRequirement,
            classRequirement: auction.classRequirement,
            itemPower: auction.itemPower
        };
        setBaseStats(temp);

        //update stats
        setImplicitStats(auction.item.basicStats ? auction.item.basicStats : [])
        setAffixStats(auction.item.stats ? auction.item.stats : []);
        setAspects(auction.item.aspects ? auction.item.aspects : []);
        setUniqueAffixes(auction.item.uniqueAffixes ? auction.item.uniqueAffixes : [])
        setSetAffixes(auction.item.setAffixes ? auction.item.setAffixes : [])
        setMythicAffixes(auction.item.mythicAffixes ? auction.item.mythicAffixes : [])
        setUpdateStatsSelects(true);
        setUpdateImplicitStatsSelects(true);
        setUpdateAspectSelects(true);
        setUpdateUniqueAffixesSelects(true);
        setUpdateSetAffixesSelects(true);
        setUpdateMythicAffixesSelects(true);
    }, [auction]);

    const convertToItemForRequest = function() {
        return convertToD4ItemForRequest(baseItem, baseStats, implicitStats, affixStats, aspects, uniqueAffixes, setAffixes, mythicAffixes, game);
    }

    return (
        <BaseEditAuctionDialog
            alert={alert}
            setAlert={setAlert}
            onClose={onClose}
            open={open}
            auction={auction}
            baseItem={baseItem}
            convertToItemForRequest={convertToItemForRequest}
            game={game}
        >
            <EiaCard>
                <D4ItemSelects showAmount={true} baseItem={baseItem} setBaseItem={setBaseItem} removeAny={true}/>
            </EiaCard>
            <EiaCard>
                <Flex direction="column" justifyContent="space-between">
                    <Flex>
                        <Heading level={4}>Basic Stats</Heading>
                        <EiaHelpButton title={"Where are the basic stats?"}>
                            <Flex justifyContent={"space-around"}>
                                <EiaImage objectFit="cover" height={300}
                                          src={helpBasicStats}/>
                            </Flex>
                        </EiaHelpButton>
                    </Flex>
                    <D4ItemBaseStatSelect baseItem={baseItem} baseStats={baseStats} setBaseStats={setBaseStats}/>
                </Flex>
            </EiaCard>
            {
                contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) ? null :
                    <EiaCard>
                        <D4ImplicitStatSelects
                            size={MAX_IMPLICIT_STATS_PER_ITEM}
                            implicitStats={implicitStats}
                            setImplicitStats={setImplicitStats}
                            updateImplicitStatsSelects={updateImplicitStatsSelects}
                            setAlert={setAlert}
                        />
                    </EiaCard>
            }
            {
                contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) ? null :
                    <EiaCard>
                        <D4AffixSelects
                            size={MAX_AFFIX_STATS_PER_ITEM}
                            affixStats={affixStats}
                            setAffixStats={setAffixStats}
                            updateStatsSelects={updateStatsSelects}

                            aspects={aspects} setAspects={setAspects}
                            updateAspectSelects={updateAspectSelects}

                            setAlert={setAlert}
                            itemCanHaveAspects={itemCanHaveAspects}

                            uniqueAffixes={uniqueAffixes} setUniqueAffixes={setUniqueAffixes}
                            updateUniqueAffixesSelects={updateUniqueAffixesSelects}

                            itemCanHaveUniqueAffixes={itemCanHaveUniqueAffixes}
                            itemCanHaveSetAffixes={itemCanHaveSetAffixes}
                            itemCanHaveMythicAffixes={itemCanHaveMythicAffixes}

                            setAffixes={setAffixes} setSetAffixes={setSetAffixes}
                            updateSetAffixesSelects={updateSetAffixesSelects}

                            mythicAffixes={mythicAffixes} setMythicAffixes={setMythicAffixes}
                            updateMythicAffixesSelects={updateMythicAffixesSelects}
                        />
                    </EiaCard>
            }
        </BaseEditAuctionDialog>
    );
}

export default D4EditAuctionDialog;